import { createReducer, on } from '@ngrx/store';
import * as ContactActions from './contact.actions';
import { ContactState, INITIAL_CONTACT_STATE } from './contact.state';

export const contactReducer = createReducer(
    INITIAL_CONTACT_STATE,
    on(ContactActions.createEmailSuccess, (state, { mailQuestionId }): ContactState => ({ ...state, mailQuestionId }))
);
